import React, {ReactNode} from 'react';
import {Trans} from '@deviceinsight/ng-ui-scale-lib/api';

export const GPIO_STATUS_TRANSLATIONS: Record<string, ReactNode> = {
	true: <Trans i18nKey="dashboard.datapointLabels.gpioStatus.high">High</Trans>,
	false: <Trans i18nKey="dashboard.datapointLabels.gpioStatus.low">Low</Trans>,
	unknown: <Trans i18nKey="dashboard.datapointLabels.gpioStatus.unknown">Unknown</Trans>
};
export const GPIO_MODE_TRANSLATIONS: Record<string, ReactNode> = {
	input: <Trans i18nKey="dashboard.datapointLabels.gpioMode.input">IN</Trans>,
	output: <Trans i18nKey="dashboard.datapointLabels.gpioMode.output">OUT</Trans>,
	unknown: <Trans i18nKey="dashboard.datapointLabels.gpioMode.unknown">?</Trans>
};
export const DEVICE_ONLINE_STATUS_TRANSLATIONS: Record<string, ReactNode> = {
	true: <Trans i18nKey="dashboard.datapointLabels.onlineStatus.online">online</Trans>,
	false: <Trans i18nKey="dashboard.datapointLabels.onlineStatus.offline">offline</Trans>,
	unknown: <Trans i18nKey="dashboard.datapointLabels.gpioStatus.unknown">unknown</Trans>
};
